import logger from '@/layers/support/monitoring/logger';
import type { EtlSponsor } from '@/types/etl';
import { fetchWrapper } from '../utils/fetchWrapper';

const LOG_MODULE = 'FE [Presentation / Services / ETL Sponsors]';

const API_URL = '/api/etl/sponsors';

export const fetchEtlSponsors = async (): Promise<Pick<EtlSponsor, 'id' | 'name'>[]> => {
  logger.debug(`${LOG_MODULE} fetchEtlSponsors: begin`);

  try {
    const result = await fetchWrapper.get<Pick<EtlSponsor, 'id' | 'name'>[]>(API_URL);

    logger.debug(`${LOG_MODULE} fetchEtlSponsors: end`, { count: result.length });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchEtlSponsors`, { error });
    throw error;
  }
};

export const fetchEtlSponsorById = async (id: number): Promise<EtlSponsor> => {
  logger.debug(`${LOG_MODULE} fetchEtlSponsorById: begin`, { id });

  try {
    const result = await fetchWrapper.get<EtlSponsor>(`${API_URL}/${id}`);

    logger.debug(`${LOG_MODULE} fetchEtlSponsorById: end`, { id });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchEtlSponsorById`, { error });
    throw error;
  }
};
